import { useState } from 'react'
import { isWeb, View, XStack } from 'tamagui'

interface IQuestionWrapperProps {
  color: string
  children: React.ReactNode
}

export function QuestionWrapper({ children, color }: IQuestionWrapperProps) {
  const [height, setHeight] = useState(0)

  return (
    <XStack
      alignItems="center"
      mb="$spacing-inset-nano"
      width="100%"
      minWidth={0}
      onLayout={(event) => setHeight(event.nativeEvent.layout.height)}
    >
      <View
        backgroundColor={color}
        borderWidth={1}
        borderRightWidth={0}
        borderColor="$border-default"
        width={8}
        height={isWeb ? height : '100%'}
        flexDirection="row"
        borderTopLeftRadius="$border-radius-sm"
        borderBottomLeftRadius="$border-radius-sm"
      />
      <XStack
        borderWidth={1}
        borderLeftWidth={0}
        borderColor="$border-default"
        borderTopRightRadius="$border-radius-sm"
        borderBottomRightRadius="$border-radius-sm"
        flex={1}
        minWidth={0}
        pl="$spacing-inset-nano"
      >
        {children}
      </XStack>
    </XStack>
  )
}
